import * as React from "react";
import * as ReactDOM from "react-dom";
import isInFrame from "../../Utils/InFrame";
import { Environment } from "../../Utils/Environment";
import { RuntimeConnectedShade } from "./RuntimeConnectedShade";

export interface HeaderProps extends React.Props<HeaderControl> {
    environment: string;
    smallHeader: boolean;
    showMainNavLink: boolean;
    showInFrame?: boolean;
    features: string[];
    smallHeaderNavHandler?: (index: SmallHeaderNavLinks) => void;
}

export enum SmallHeaderNavLinks {
    root,
    mybots,
    documentation,
    blog,
    register,
    create
}

export class HeaderControl extends React.Component<HeaderProps, {}> {
    constructor(props: HeaderProps) {
        super(props);
    }

    public render(): JSX.Element {
        // Hide the header in Ibiza
        if (Environment.isInBotFrameworkAzureExtension) {
            return null;
        }

        if (!this.props.showInFrame && isInFrame()) {
            return null;
        }
        var environmentDisplay: JSX.Element = null;

        if (this.props.environment && this.props.environment != 'prod') {
            environmentDisplay = <span className="environment">{'[ ' + this.props.environment + ' environment ]'}</span>
        }

        let mainNavLink = (this.props.showMainNavLink)
            ? <a className="main-nav-link" disabled={true} onClick={e => { e.preventDefault();}}>Bot Framework</a>
            : null;

        if (this.props.smallHeader) {
            const botsClick = (ev: React.MouseEvent<HTMLElement>) => {
                ev.preventDefault();
                this.props.smallHeaderNavHandler(SmallHeaderNavLinks.mybots);
            }
            const documentationClick = (ev: React.MouseEvent<HTMLElement>) => {
                ev.preventDefault();
                this.props.smallHeaderNavHandler(SmallHeaderNavLinks.documentation);
            }
            const blogClick = (ev: React.MouseEvent<HTMLElement>) => {
                ev.preventDefault();
                this.props.smallHeaderNavHandler(SmallHeaderNavLinks.blog);
            }
            return (
                <div className="small-header cover-container">
                    {mainNavLink}
                    <a className="nav-link" href='/bots' onClick={botsClick}>My bots</a>
                    <a className="nav-link" href='//docs.microsoft.com/en-us/bot-framework/' onClick={documentationClick}>Documentation</a>
                    <a className="nav-link" href='https://blog.botframework.com' onClick={blogClick}>Blog</a>
                    {environmentDisplay}
                    {this.props.children}
                    <RuntimeConnectedShade></RuntimeConnectedShade>
                </div>
            );
        } else {
            return (
                <header className="cover-container">
                    <div className="outline">
                        <div className="header outline">
                            <a className="logo" href="//www.microsoft.com">
                                <svg className="svgicon svgicon-microsoft-color-logo" aria-label="Microsoft">
                                    <use xlinkHref="Client/Images/symbol-defs.svg#svgicon-microsoft-color-logo">
                                    </use>
                                </svg>
                            </a>
                            {environmentDisplay}
                            {this.props.children}
                        </div>
                    </div>
                    <RuntimeConnectedShade></RuntimeConnectedShade>
                </header>);
        }
    }

    private onShadeVisibilityChanged = (b: boolean) => {
        console.log("Shader changed!!", b);
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/v4/HeaderControl.tsx